import { Link } from 'react-router-dom'
import React from 'react'

export function BreadcrumbLink({ to, children }: { to: string; children: React.ReactNode }) {
  const bcStyle = {
    textDecoration: 'none',
    color: 'var(--text2)',
    fontSize: '0.75rem',
    transition: 'color 0.2s',
  }
  const bcHover = (e: React.MouseEvent<HTMLAnchorElement>, enter: boolean) => {
    if (enter) e.currentTarget.style.color = 'var(--text0)'
    else e.currentTarget.style.color = 'var(--text2)'
  }
  return (
    <Link to={to} style={bcStyle} onMouseEnter={(e) => bcHover(e, true)} onMouseLeave={(e) => bcHover(e, false)}>
      {children}
    </Link>
  )
}

export function Breadcrumbs({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24, fontSize: '0.75rem', color: 'var(--text3)' }}>
      {children}
    </div>
  )
}

export function BreadcrumbSeparator() {
  return <span>/</span>
}
